// Resolves the base URL that customer-facing links (proposal page, Stripe
// success/cancel) should render on.
//
// Precedence:
//   1. REACT_APP_PUBLIC_BASE_URL — set this in the DEPLOYMENT env once the
//      custom domain (e.g. app.getmainstreet.co) is live and verified. This
//      forces branded URLs even when a rep is browsing the emergent.host
//      preview.
//   2. window.location.origin — default. Whichever domain the rep is on is
//      the domain the link points to. Works for a rep browsing the custom
//      domain, and for local dev.
//
// Trailing slash is stripped for clean concatenation.
export function getPublicBaseUrl() {
  const configured = (process.env.REACT_APP_PUBLIC_BASE_URL || "").trim();
  if (configured) return configured.replace(/\/+$/, "");
  if (typeof window !== "undefined" && window.location && window.location.origin) {
    return window.location.origin.replace(/\/+$/, "");
  }
  return "";
}
